import SweetScroll from 'sweet-scroll';

// スムースクロールを実装するための関数
function sweetScroll() {
  const scroller = new SweetScroll({
    offset: 0,
    vertical: true,
    easing: 'easeOutQuint',
    horizontal: false,
    cancellable: true,
    updateURL: false,
    preventDefault: true,
    stopPropagation: true,
  });

  scroller.update({
    trigger: 'a[href^="#"]',
    duration: 1000,
  });
}

// トップへ戻るボタンの制御（PCの時のみ）
function backToTopButton() {
  const button = document.querySelector('footer .page-top-fixed');
  const footer = document.getElementById('footer');
  const pageHeight = document.body.scrollHeight;
  const footerHeight = footer.scrollHeight;
  const buttonAppearPos = window.innerHeight * 1.5; // 画面の高さの1.5倍の距離をスクロールしたらボタンを表示
  const buttonDisappearPos = pageHeight - footerHeight;

  if (window.innerWidth > 749 && buttonAppearPos < pageHeight) { // PCレイアウトかつ画面の1.5倍の高さよりもコンテンツの全長が長い時に処理を行う
    window.addEventListener('scroll', () => {
      const scrollDistance = window.scrollY + window.innerHeight;

      if (scrollDistance > buttonAppearPos && scrollDistance < buttonDisappearPos) {
        button.classList.remove('hidden');
      } else {
        button.classList.add('hidden');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  sweetScroll();
  backToTopButton();
});

// SPメニューの表示と非表示
toggleMobileMenu();
function toggleMobileMenu() {
  const toggleButton = document.querySelector('.header__toggle');
  const spNav = document.querySelector('.header__sp-nav');

  toggleButton.addEventListener('click', () => {
    if (!toggleButton.classList.contains('open') && !toggleButton.classList.contains('close')) {
      toggleButton.classList.add('open');
      spNav.classList.add('open');
      return;
    };

    if (toggleButton.classList.contains('open')) {
      toggleButton.classList.remove('open');
      spNav.classList.remove('open');
      toggleButton.classList.add('close');
    } else {
      toggleButton.classList.remove('close');
      toggleButton.classList.add('open');
      spNav.classList.add('open');
    }
  });
}
